export const getSavagninFranceData = () => ({
  name: "Savagnin",
  country: "France",
  region: "Jura",
  description: "Le Savagnin est un cépage unique et emblématique du Jura, base exclusive du vin jaune et du vin de paille. Ce cépage, avec son acidité élevée et son potentiel oxydatif exceptionnel, produit des vins d'une complexité aromatique remarquable. Le Savagnin est l'expression même de la tradition viticole jurassienne et de ses méthodes ancestrales.",
  type: "grape",
  color: "Blanc",
  origin: "Jura, France",
  characteristics: {
    "Peau": "Épaisse et résistante",
    "Couleur": "Jaune doré à ambré",
    "Acidité": "Très élevée",
    "Alcool": "Élevé (13-15%)",
    "Rendement": "Faible à moyen",
    "Maturité": "Très tardive"
  },
  aromas: {
    "Primaires": ["Citron", "Pamplemousse", "Fruits exotiques", "Fruits secs"],
    "Secondaires": ["Noix", "Amandes", "Curry", "Épices"],
    "Tertiaires": ["Miel", "Cire d'abeille", "Notes oxydatives", "Notes de rancio"]
  },
  viticulture: {
    "Climat": "Semi-continental avec influences montagneuses",
    "Sol": "Marnes grises et bleues du Jurassique",
    "Exposition": "Sud et sud-est, exposition chaude",
    "Altitude": "250-450 mètres",
    "Taille": "Guyot simple, taille longue",
    "Rendement": "35-50 hl/ha"
  },
  vinification: {
    "Vin Jaune": {
      "Récolte": "Vendanges tardives, raisins surmûris",
      "Pressurage": "Pressurage doux",
      "Fermentation": "Fermentation alcoolique en fûts",
      "Élevage": "6 ans minimum sous voile de levures",
      "Ouillage": "Aucun (oxydation contrôlée)"
    },
    "Vin Blanc Sec": {
      "Récolte": "Vendanges normales",
      "Pressurage": "Pressurage doux",
      "Fermentation": "Fermentation contrôlée",
      "Élevage": "12-18 mois sur lies fines"
    },
    "Vin de Paille": {
      "Récolte": "Vendanges manuelles, raisins surmûris",
      "Séchage": "2-3 mois sur paille",
      "Pressurage": "Pressurage doux, moût concentré",
      "Fermentation": "Fermentation lente",
      "Élevage": "18-24 mois en fûts"
    }
  },
  wineStyles: {
    "Vin Jaune": "Vin blanc oxydatif unique au monde, élevé sous voile de levures. Notes de noix, curry, épices, amandes. Très longue garde (50+ ans).",
    "Vin Blanc Sec": "Vins blancs secs et minéraux, avec une belle acidité et des arômes complexes.",
    "Vin de Paille": "Vin liquoreux rare et précieux, notes de fruits secs, miel, épices."
  },
  regions: {
    "Jura": {
      "Château-Chalon": "Vin jaune exclusif, expression ultime",
      "Arbois": "Vin jaune et vins blancs secs",
      "L'Étoile": "Vin de paille et vins blancs secs",
      "Côtes du Jura": "Tous styles autorisés"
    }
  },
  statistics: {
    "Surface en France": "200 hectares",
    "Production": "8,000 hectolitres",
    "Concentration": "Jura (100%)",
    "Tendance": "Stable"
  },
  history: "Le Savagnin est un cépage ancien du Jura, probablement d'origine locale. Les techniques d'élevage sous voile de levures remontent au Moyen Âge et ont été développées par les moines. Le vin jaune était traditionnellement offert aux rois de France et reste aujourd'hui l'un des vins les plus prestigieux du Jura. Le Savagnin est le cépage emblématique de la tradition viticole jurassienne.",
  foodPairing: "Vin Jaune : Comté vieux (24-36 mois), foie gras, volaille au vin jaune, curry, cuisine asiatique. Vin Blanc Sec : Poissons nobles, crustacés, fromages affinés. Vin de Paille : Desserts aux fruits secs, fromages bleus, foie gras."
}); 